import React from "react";
import { ReactComponent as GITHUB } from "../img/social_icons/github.svg";

export const GitHub = () => {
  return <GITHUB title="github" />;
};
